<div class="backModal enCalendar">
  <div class="close closeModal">
    <a (click)="close()" title="cerrar"><span class="cross"></span><span class="sr-only">cerrar</span></a>
  </div>
  <div class="aviso">
    <div class="tituloSearch">
      {{ 'MENSAJE_ENTRADA_LOCALIZADOR' | translateV2 }}
    </div>
    <div class="faturacion-fila">
      <div class="ticket-info">
        <div class="inputControl botones">
          <button type="button" value="cancelar" class="cancelar" (click)="close()">
            {{ 'CANCELAR' | translateV2 }}
          </button>
        </div>
      </div>
      <div class="ticket-info">
        <div class="inputControl botones">
          <button type="button" value="ACEPTAR" class="pagar aceptar" (click)="imprimirTicketsLocalizador()">
            {{ 'ACEPTAR' | translateV2 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
